import { PdsWidget, StringBoolean } from './pds-widget';
import { pdsUtils } from './pds-utils';
import { ImmersiveReaderService } from './services/immersive-reader-service';
import { pdsI18n } from './pds-i18n';
import { ImmersiveReaderContentCallback, ImmersiveReaderTitleCallback } from './interfaces/immersive-reader-config';

export class PdsImmersiveReader extends PdsWidget {
  is = 'pds-immersive-reader';

  id?: string;

  dataTitle?: string;
  dataTitleSelector?: string;

  dataContent?: string;
  dataContentArray?: Array<string>;
  dataContentSelector?: string;
  dataContentSeparator?: string;

  dataContentLanguage?: string;
  dataUiLanguage?: string;

  titleCallback?: ImmersiveReaderTitleCallback;
  contentCallback?: ImmersiveReaderContentCallback;

  showButton = false;
  set dataShowButton(value: StringBoolean) {
    this.showButton = pdsUtils.getStringBooleanValue(value);
  }

  showIcon = true;
  set dataShowIcon(value: StringBoolean) {
    this.showIcon = pdsUtils.getStringBooleanValue(value);
  }

  showText = true;
  set dataShowText(value: StringBoolean) {
    this.showText = pdsUtils.getStringBooleanValue(value);
  }

  showTooltip = true;
  set dataShowTooltip(value: StringBoolean) {
    this.showTooltip = pdsUtils.getStringBooleanValue(value);
  }

  properties = {
    id: {
      type: String
    },
    dataTitle: {
      type: String
    },
    dataTitleSelector: {
      type: String
    },
    dataContent: {
      type: String
    },
    dataContentArray: {
      type: Array
    },
    dataContentSelector: {
      type: String
    },
    dataContentLanguage: {
      type: String
    },
    dataContentSeparator: {
      type: String
    },
    dataUiLanguage: {
      type: String
    },
    dataShowButton: {
      type: String,
      value: 'false'
    },
    dataShowIcon: {
      type: String,
      value: 'true'
    },
    dataShowText: {
      type: String,
      value: 'true'
    },
    dataShowTooltip: {
      type: String,
      value: 'true'
    },
    tooltipDirection: {
      type: Object
    }
  };

  private immersiveReaderService: ImmersiveReaderService;

  attached(): void {
    super.attached();

    if (!this.showText && !this.showIcon) {
      console.warn('Both the text and icon have been hidden for an immersive reader element, so it cannot be seen.');
    }
  }

  //Polymer hook - called immediately after the constructor was called.
  //NOTE: member variables set here can not be directly accessed in the template.
  created(): void {
    this.immersiveReaderService = new ImmersiveReaderService(this.asElement());
  }

  startImmersiveReader(): void {
    let config = {
      content: this.dataContent,
      contentArray: this.dataContentArray,
      contentCallback: this.contentCallback,
      contentLanguage: this.dataContentLanguage,
      contentSelector: this.dataContentSelector,
      contentSeparator: this.dataContentSeparator,
      title: this.dataTitle,
      titleSelector: this.dataTitleSelector,
      titleCallback: this.titleCallback,
      uiLanguage: this.dataUiLanguage
    };

    this.immersiveReaderService.start(config).subscribe(
      () => this.emitOpen(),
      () => pdsUtils.fireMessageEvent(this.asElement(),
          pdsI18n.getText('pds|immersive-reader|Functionality not available because of invalid configuration.  Please contact your system administrator.'), 'ERROR'),
      () => this.emitClose());
  }

  private emitClose(): void {
    this.dispatchEvent(new Event('close'));
  }

  private emitOpen(): void {
    this.dispatchEvent(new Event('open'));
  }
}
